<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">ContactRole Details</h4>
            <v-simple-table v-if="$route.params.id != 0">
              <tbody>
                <tr>
                  <td>ContactRole Name</td>
                  <td>
                    {{ contactRoleModel.name ? contactRoleModel.name : "" }}
                  </td>
                </tr>
                <tr>
                  <td>ContactRole Id</td>
                  <td>
                    {{ contactRoleModel.id ? contactRoleModel.id : "" }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-btn
              v-if="$route.params.id == 0"
              color="primary"
              large
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Create a New ContactRole</v-btn
            >
            <v-btn
              v-else
              large
              color="primary"
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Edit</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ContactRole } from "@/models/ContactRole";
import { gql } from "apollo-boost";
export default {
  data() {
    return {
      isEdit: false,
      contactRoleModel: new ContactRole(),
      me: "",
      search: null,
      crumbs: [
        {
          text: "ContactRoles",
          disabled: false,
          href: "/admin/contactRoles",
        },
        {
          text: "ContactRole Details",
          disabled: false,
          href: `/admin/contactRoles/${this.$route.params.id}`,
        },
      ],
    };
  },
  created() {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    contactRole: {
      query: gql`
        query ContactRole($id: ID!) {
          contactRole(id: $id) {
            id
            name
            createdBy
            createdAt
            updatedAt
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id || this.$route.params.id == 0;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
          createdBy: self.me.id,
        };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result(response, key) {
        this.isLoading = false;
        this.contactRoleModel.id = this.contactRole.id;
        this.contactRoleModel.name = this.contactRole.name;
        this.contactRoleModel.createdBy = this.contactRole.createdBy;
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
